import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { Provider } from "react-redux";
import { unstable_HistoryRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import { PersistGate } from "redux-persist/integration/react";
// ?===========Slick Data=============
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
// ?===========Swiper Data=============
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import App from "./App";
import Loader from "./components/GeneralComponents/Loader";
import { AuthProvider } from "./context/AuthContext";
import history from "./hooks/History";
import i18n from "./i18n";
import "./index.css";
import { persistor, store } from "./redux/store";
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router history={history}>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <PersistGate
              loading={
                <div className="flex h-full min-h-screen w-full flex-col items-center justify-center">
                  <Loader radius={50} />
                </div>
              }
              persistor={persistor}
            >
              <React.Suspense
                fallback={
                  <div className="flex h-full min-h-screen w-full flex-col items-center justify-center">
                    <Loader radius={50} />
                  </div>
                }
              >
                <I18nextProvider i18n={i18n}>
                  <App />
                </I18nextProvider>
              </React.Suspense>
            </PersistGate>
            <ReactQueryDevtools initialIsOpen={false} />
          </Provider>
        </QueryClientProvider>
      </Router>
    </AuthProvider>
  </React.StrictMode>,
);
